import smoothscroll from 'smoothscroll-polyfill';
import { isSafari } from './helpers/isSafari';
import 'container-query-polyfill';

if (isSafari()) smoothscroll.polyfill();
